import { useTranslation } from 'react-i18next'
import HeroSection from './HomeComponents/HeroSection'
import TrustedSection from './HomeComponents/TrustedSection'

import '../../assets/assets-homepage/css/reset.scss'
import '../../assets/assets-homepage/css/page.scss'
import '../../assets/assets-homepage/fonts/Inter/stylesheet.css'

import ServicesSlider from './HomePageComponents/ServicesSlider'
import Feedback from './HomePageComponents/Feedback'
import CremeSection from './HomePageComponents/CremeSlider'
import WhyUs from './HomePageComponents/WhyUs'
import Founder from './HomePageComponents/Founder'
import BecomeClient from './HomePageComponents/BecomeClient'
import ClientsChooseSlider from './HomePageComponents/ClientsChooseSlider'
import XploriusEditSlider from './HomePageComponents/XploriusEditSlider'
import InstagramPostsSlider from './HomePageComponents/InstagramPostsSlider'
import { PublicHeader, PublicFooter } from '../../components/common'
import { FaqSection } from './HomeComponents/FaqSection'
import Whatsapp from './HomePageComponents/Whatsapp'
import CraftedSection from './HomePageComponents/CraftedSection'

export const Home = () => {
    const { t } = useTranslation('common')
    const homeNavLinks = [
        { label: t('nav.home.services'), href: '#services' },
        { label: t('nav.safari.maldives'), href: '/maldives' },
        { label: t('nav.maldives.luxurySafari'), href: '/safari' },
    ]
    return <>
        <PublicHeader
            variant={window.innerWidth > 640 ? 'light' : 'dark'}
            navLinks={homeNavLinks}
            showLanguageSwitcher={true}
            position={window.innerWidth > 640 ? 'static' : 'absolute'}
        />

        <main>
            <HeroSection />
            <div className="homePage wrapper">
                <CraftedSection />
                <TrustedSection />
                <Whatsapp />
                <ServicesSlider />
                <Feedback />
                <XploriusEditSlider />
                <CremeSection />
                <WhyUs />
                <Founder />
                <BecomeClient price={20000} />
                <InstagramPostsSlider />
                <ClientsChooseSlider />
            </div>

            <FaqSection />
        </main>

        <PublicFooter />
    </>

}
